import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import { Loader } from '../../components/ui';
import { LoginForm } from './components/LoginForm';
import { LoginBrandPanel } from './components/LoginBrandPanel';
import './login.styles.css';

/**
 * Modern Login Page
 *
 * Features:
 * - Responsive split layout (desktop: 40% brand / 60% form, mobile: centered card)
 * - Modern SaaS design with gradients and smooth animations
 * - Integration with existing auth system via useAuth hook
 */
export default function LoginPage() {
	const navigate = useNavigate();
	const { isAuthenticated, isLoading, enforcePasswordChange } = useAuth();

	// Redirect if already authenticated
	useEffect(() => {
		if (isAuthenticated && !isLoading) {
			if (enforcePasswordChange) {
				navigate('/change-password', { replace: true });
			} else {
				navigate('/', { replace: true });
			}
		}
	}, [isAuthenticated, isLoading, enforcePasswordChange, navigate]);

	// Show loading overlay while checking auth status
	if (isLoading) {
		return (
			<div className="login-page">
				<Loader variant="fullscreen" message="Checking authentication..." />
			</div>
		);
	}

	return (
		<div className="login-page">
			<div className="login-container">
				{/* Left panel - Branding (hidden on mobile) */}
				<LoginBrandPanel />

				{/* Right panel - Login form */}
				<div className="login-form-panel">
					<div className="login-form-wrapper">
						<LoginForm />
					</div>
				</div>
			</div>
		</div>
	);
}
